import React from 'react'
import { LearningItemAsPath } from '../../models/LearningItem'
import { useTranslation } from 'react-i18next'
import usePathLearningItems from '../../state/queries/usePathLearningItems'
import CourseLearningPathLearningItem from './CourseLearningPathLearningItem'
import styles from './CourseLearningPathPage.module.scss'

export default function CourseLearningPathLearningItems({
  learningItemAsPath,
}: {
  learningItemAsPath: LearningItemAsPath
}) {
  const { t } = useTranslation()

  const { pathLearningItems } = usePathLearningItems(learningItemAsPath.uuid)

  return (
    <section className={styles.CourseLearningPathLearningItems}>
      <h1>{t('learning path.courses list title')}</h1>
      <main>
        {pathLearningItems.map((learningItem) => (
          <CourseLearningPathLearningItem key={learningItem.uuid} learningItem={learningItem} />
        ))}

        {0 === pathLearningItems.length && (
          <div className={styles.emptyList}>{t('learning path.no learning items')}</div>
        )}
      </main>
    </section>
  )
}
